import * as React from 'react';
import {
  Box,
  createStyles,
  makeStyles,
  Theme,
  Divider,
} from '@material-ui/core';
import TopDeviceIssuesChart from './TopDeviceIssuesChart';
import TopStoresWithLanesDownChart from './TopStoresWithLanesDownChart';
import TopStoresWithDeviceIssues from './TopStoresWithDeviceIssues';
import DeviceIssuesByCategoryChart from './DeviceIssuesByCategoryChart';
import DeviceWidgetTotalCountTile from './DeviceWidgetTotalCountTile';
import StringResourceManager from '../StringResourceManager';

// Styles
const useStylesDevicesOverview = makeStyles((theme: Theme) =>
  createStyles({
    widgetBox: {
      margin: theme.spacing(2),
      overflow: 'hidden',
      width: '965px',
    },
    flexBox: {
      flex: 1,
    },
    chart: {
      flex: 1,
    },
    chartContainer: {
      display: 'flex',
      flexDirection: 'row',
      flex: 1,
    },
    margin: {
      marginTop: 5,
    },
    overViewTitle: {
      display: 'flex',
      justifyContent: 'center',
    },
  })
);

export default function DevicesOverview() {
  const classes = useStylesDevicesOverview();

  return (
    <React.Fragment>
      <Box className={classes.widgetBox}>
        <div className={classes.overViewTitle}>
          <StringResourceManager
            stringKey="DEVICE_STATUS_SUMMARY"
            style="overViewTitle"
          />
        </div>
        <DeviceWidgetTotalCountTile />
        <Divider />
        <div className={classes.flexBox}>
          <div className={classes.chartContainer}>
            <div className={classes.chart}>
              <TopDeviceIssuesChart />
            </div>
            <div className={classes.chart}>
              <TopStoresWithDeviceIssues />
            </div>
          </div>
          <div className={classes.chartContainer}>
            <div className={classes.chart}>
              <DeviceIssuesByCategoryChart />
            </div>
            <div className={classes.chart}>
              <TopStoresWithLanesDownChart />
            </div>
          </div>
        </div>
      </Box>
    </React.Fragment>
  );
}
